if (!customElements.get('article-contents')) {
  customElements.define('article-contents', class ArticleContents extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialised === 'true') return;
      this.dataset.initialised = 'true';
      const article = document.querySelector('[data-article-body]');
      const list = this.querySelector('ol');
      if (!article || !list) return;
      const headings = [...article.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
      if (headings.length < Number(this.dataset.minimum || 3)) {
        this.hidden = true;
        return;
      }
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `article-section-${index + 1}`;
        const item = document.createElement('li');
        if (heading.tagName === 'H3') item.classList.add('is-nested');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
    }
  });
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', class NewsletterForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialised === 'true') return;
      this.dataset.initialised = 'true';
      this.querySelector('form')?.addEventListener('submit', () => {
        this.dispatchEvent(new CustomEvent('ads:newsletter_submit', { bubbles: true }));
      });
    }
  });
}


if (!customElements.get('guide-progress')) {
  customElements.define('guide-progress', class GuideProgress extends HTMLElement {
    connectedCallback() {
      this.sent = false;
      this.article = document.querySelector('[data-article-body]');
      if (!this.article) return;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.sent || !this.article) return;
      const rect = this.article.getBoundingClientRect();
      const total = Math.max(this.article.offsetHeight, 1);
      const viewed = Math.min(Math.max(window.innerHeight - rect.top, 0), total);
      if (viewed / total < 0.75) return;
      this.sent = true;
      this.dispatchEvent(new CustomEvent('ads:guide_read', {
        bubbles: true,
        detail: { progress: 75, article_id: document.body.dataset.articleId }
      }));
      window.removeEventListener('scroll', this.onScroll);
    }
  });
}

